<template>
  <v-footer class="footer" style="z-index:105 !important" app>
    <span :class="isPhoneBool ? 'transparent--text' : 'white--text'">&copy; Qwips Service Solutions</span>
    <v-btn v-if="!isProd" dark x-small icon style="position: absolute; margin-left: 160px;" @click="toggleDarkMode()">
      <v-icon size="14">mdi-theme-light-dark</v-icon>
    </v-btn>
    <div class="buttoncontainer">
      <v-badge overlap transition="slide-y-reverse-transition" :content="TaskCount" :value="TaskCount" color="tertiary"
        id="specialbadge">
        <v-btn class="footerbtn rounded-t-0" dark x-small color="backgroundworker" :text="!TaskListOpen" shaped
          :disabled="TaskCount < 1" @click="$store.dispatch('toggleBackgroundWork')">
          <v-icon size="18" class="d-flex align-self-center" color="white">{{ taskManagerConnectionIcon }}</v-icon>
        </v-btn>
      </v-badge>
      <store-inspector></store-inspector>
      <v-btn @click="backToOld()" class="footerbtn white--text" :color="olderror ? 'error' : '#2a2a2a'"
        v-if="$store.state.GlobalSettings && !$store.state.GlobalSettings.IsSaasMode">
        <v-icon size="15" class="mr-1">mdi-web-sync</v-icon>
        {{ isPhoneBool ? '' : $t('servicesystem.common_objects.fallbackterms.old_site') }}
      </v-btn>
    </div>
  </v-footer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import StoreInspector from "@/components/Buttons/StoreInspector.vue";

export default {
  name: "PageFooter",
  components: { StoreInspector },
  mixins: [clientAPI],

  data() {
    return {
      increment: 0,
      darkMode: false,
      olderror: false,
    };
  },

  mounted() { },

  methods: {
    gotoabout() {
      this.$router.push({ name: "About" });
    },
    toggleDarkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.darkMode = !this.darkMode;
    }
  },

  computed: {
    taskManagerConnectionIcon() {
      if (this.$store.state.NotificationStore.connectionState == "Connected")
        return "mdi-playlist-play";
      else return "mdi-playlist-remove";
    },
    TaskCount() {
      return this.$store.getters.backgroundAllTaskCount;
    },
    TaskListOpen() {
      return !this.$store.getters.taskListMinimized && this.TaskCount > 0;
    },
    isProd() {
      return (process.env.NODE_ENV === 'production');
    },
  },

  watch: {
    '$route.name': function () {
      if (!this.isProd) {
        var result = this.transformToOldGuiRoute(this.$route);
        if (result.includes('undefined')) {
          this.olderror = true;
          console.error('transformToOldGuiRoute', this.$route.name, result);
        }
        else {
          this.olderror = false;
        }
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.buttoncontainer {
  position: absolute;
  right: 148px;
}

.footerbtn {
  height: 30px !important;
  text-transform: none;
}

.footerbtn.second {
  margin-right: -3px;
}

.footer {
  padding: 5.7px 16px !important;
}

.bounce-enter-active {
  animation: bounce-in 0.5s;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}
</style>